import "./App.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { AssetUpload, MyPage } from "./Pages";
import { AssetDetail } from "./AssetDetail";
//import { AssetList } from "./AssetList";
import { SignUp } from "./SignUp";
import { SignIn } from "./SignIn";
import { EditMember } from "./EditMember";
import { EditGroup } from "./EditGroup";
import { EditReportUser } from "./EditReportUser";
import { Report } from "./Report";
import { Whoops404 } from "./Whoops404";
import { EditOwnedGroup } from "./EditOwnedGroup";
import { EditMeasurement } from "./EditMeasurement";
import { Home } from "./Home";
import { History } from "./History";
import { HistoryDetail } from "./HistoryDetail";
import { ImportMembersCsv } from "./ImportMembersCsv";
import { ForgotPassword } from "./ForgotPassword";
import { ResetPassword } from "./ResetPassword";
import { ValidateMainMember } from "./ValidateMainMember";
import { ImportJDCMembersCsv } from "./ImportJDCMembersCsv";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/assetDetail/:assetId" element={<AssetDetail />} />
        <Route path="/assetUpload" element={<AssetUpload />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/SignIn" element={<SignIn />} />
        <Route path="/myPage" element={<MyPage />} />

        <Route
          path="/ValidateMainMember/:UserName/:Token"
          element={<ValidateMainMember />}
        />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/ResetPassword/:Token" element={<ResetPassword />} />
        <Route path="/EditMember" element={<EditMember />} />
        <Route path="/EditGroup" element={<EditGroup />} />
        <Route path="/EditOwnedGroup" element={<EditOwnedGroup />} />
        <Route path="/EditMeasurement" element={<EditMeasurement />} />
        <Route path="/ImportMemberCsv" element={<ImportMembersCsv />} />
        <Route path="/Report" element={<Report />} />
        <Route path="/EditReportUser" element={<EditReportUser />} />
        <Route path="/History" element={<History />} />
        <Route
          path="/HistoryDetail/:YearMonth/:OrgUserId"
          element={<HistoryDetail />}
        />
        <Route path="/ImportJDCMembersCsv" element={<ImportJDCMembersCsv />} />
        <Route path="*" element={<Whoops404 />} />
      </Routes>
    </div>
  );
}

export default App;
